/** @format */

import { api } from 'utility';
import {
  getServiceCallUrl,
  getServiceCallVersionUrl,
  getChangeServiceCallStatusUrl,
  getServiceSetRelatedServiceCallUrl,
  getServiceSetUrl,
} from 'URLs';
export function serviceCallAddApi(params) {
  return api.post(getServiceCallUrl(), {
    ...params,
  });
}

export function serviceCallEditApi(params) {
  return api.put(getServiceCallUrl(), {
    ...params,
  });
}

export function updateCustomPost(params) {
  return api.put(getServiceSetUrl(), {
    ...params,
  });
}

export function serviceCallListApi(param) {
  return api.get(getServiceCallUrl(), { params: { ...param } }).then((res) => res.data);
}

export function versionService(param) {
  return api.get(getServiceCallVersionUrl(), { params: { ...param } }).then((res) => res.data);
}

export function serviceCall(param) {
  return api.get(getServiceCallUrl(), {
    params: { ...param },
  });
}

export function changeStatusWebServiceApi(params) {
  return api.put(
    getChangeServiceCallStatusUrl(params.serviceCallId),
    {},
    {
      params,
    },
  );
}

export function serviceSetRelatedServiceApi(id) {
  return api.get(getServiceSetRelatedServiceCallUrl(id)).then((res) => res.data);
}
